import { render } from "./IndexPenyedia.vue?vue&type=template&id=71f3a857"
import script from "./IndexPenyedia.vue?vue&type=script&lang=js"
export * from "./IndexPenyedia.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/pengadaan/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__